"use client";
import { skipTracking } from "../tracker";
import { AutoTracker } from "./AutoTracker";
import { Analytics as VaAnalytics } from "@vercel/analytics/react";

export function Analytics() {
  return (
    <>
      <AutoTracker />
      <VaAnalytics
        beforeSend={(event) => {
          if (skipTracking()) return null;
          return event;
        }}
      />
    </>
  );
}
